import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import AvailableUnits from "../components/AvailableUnits";
import Gallery from "../components/Gallery";
import CTA from "../components/CTA";
import Footer from "../components/Footer";
import InterestForm from "../components/InterestForm";
import { openBooking, getUnits } from "../api";

const Home = () => {
  const [formOpen, setFormOpen] = useState(false);
  const [unitNumber, setUnitNumber] = useState("");
  const [units, setUnits] = useState([]);

  useEffect(() => {
    getUnits().then(setUnits).catch(() => setUnits([]));
  }, []);

  const openForm = (unit = "") => {
    setUnitNumber(unit || "");
    setFormOpen(true);
  };

  return (
    <div className="bg-[#F3ECE0]">
      <Navbar onRegister={() => openForm()} onBook={openBooking} />
      <Hero onRegister={() => openForm()} onBook={openBooking} />
      <About />
      <Services />
      <AvailableUnits units={units} onRegister={openForm} />
      <Gallery />
      <CTA onRegister={() => openForm()} onBook={openBooking} />
      <Footer />
      <InterestForm open={formOpen} onOpenChange={setFormOpen} unitNumber={unitNumber} />
    </div>
  );
};

export default Home;
